import React, { useState } from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border border-[#252b45]/50 rounded-xl overflow-hidden" data-id="element-39">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-5 md:p-6 text-left
          focus:outline-none focus:ring-2 focus:ring-[#c9a84c]/50 focus:ring-inset
          cursor-pointer" aria-expanded={isOpen} data-id="element-40">
        <span className="text-[#e8e6e1] font-medium text-sm md:text-base pr-4" data-id="element-41">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-[#c9a84c] flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-42" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-43">
        <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-44">
          <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-45">{answer}</p>
        </div>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <SectionWrapper id="faq" data-id="element-46">
      <div className="max-w-3xl mx-auto" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <p className="text-[#c9a84c] text-sm font-semibold tracking-[0.2em] uppercase mb-6" data-id="element-49">
            Preguntas frecuentes
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-[#e8e6e1]" data-id="element-50">
            Resolvemos tus dudas
          </h2>
        </div>

        <div className="space-y-3" data-id="element-51">
          <FAQItem question="¿Esto realmente funciona o es otro curso más?" answer="Este no es un curso. Es un protocolo de reprogramación basado en neuroplasticidad y psicología de identidad. No te enseña teoría — te guía paso a paso para cambiar los patrones subconscientes que te mantienen estancado. Los resultados los sientes desde la primera semana." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-52" />

          <FAQItem question="¿Cuánto tiempo necesito dedicarle al día?" answer="Entre 15 y 30 minutos diarios. El protocolo está diseñado para integrarse en tu rutina sin disrumpir tu vida. Los audios de reprogramación puedes escucharlos mientras duermes o descansas." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-53" />

          <FAQItem question="¿Funciona si ya probé muchas cosas antes?" answer="Especialmente si ya probaste muchas cosas. El hecho de que nada haya funcionado permanentemente confirma que el problema está en tu identidad subconsciente, no en los métodos. Este protocolo ataca exactamente esa raíz que los demás ignoran." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-54" />

          <FAQItem question="¿Es contenido religioso?" answer="No. El componente espiritual del protocolo se basa en prácticas de conexión interior respaldadas por la ciencia (meditación, mindfulness, coherencia cardíaca). Es compatible con cualquier creencia o sin ninguna." isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-55" />

          <FAQItem question="¿Cómo recibo el material?" answer="Inmediatamente después del pago recibes acceso completo a todo el material digital: ebook, audiobook, bonos, audios de reprogramación y el sistema de integración. Todo descargable y accesible desde cualquier dispositivo." isOpen={openIndex === 4} onToggle={() => handleToggle(4)} data-id="element-56" />

          <FAQItem question="¿Tiene garantía?" answer="Sí. Si aplicas el protocolo durante 21 días y no experimentas un cambio real en tu claridad mental, disciplina y control emocional, te devolvemos el 100% de tu inversión. Sin preguntas." isOpen={openIndex === 5} onToggle={() => handleToggle(5)} data-id="element-57" />

          <FAQItem question="¿Por qué cuesta solo $27 si el valor es $297?" answer="Porque estamos en fase de lanzamiento y queremos que el mayor número de personas serias accedan al protocolo. Este precio es temporal y subirá sin previo aviso una vez que cerremos esta ventana de acceso." isOpen={openIndex === 6} onToggle={() => handleToggle(6)} data-id="element-58" />
        </div>
      </div>
    </SectionWrapper>;
}